module.exports = __webpack_public_path__ + "img/10019.42816dcc.jpg";